var _style, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes tiktok{0%,to{transform:translate(0)}20%{transform:translate(-.3px,.3px)}40%{transform:translate(-.3px,-.3px)}60%{transform:translate(.3px,.3px)}80%{transform:translate(.3px,-.5px)}}")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 5.194,
    y: 5,
    stroke: "#0E081A",
    strokeWidth: 1.5,
    rx: 2
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AD80CE",
    d: "M15.523 10.047a2.242 2.242 0 01-1.182-.66 2.06 2.06 0 01-.549-1.195V8H12.21v5.967c0 .265-.087.523-.25.738a1.324 1.324 0 01-.655.46 1.392 1.392 0 01-.815.008 1.328 1.328 0 01-.667-.447A1.208 1.208 0 019.69 13.4c.111-.21.281-.388.492-.511a1.416 1.416 0 011.105-.131V11.23a3.007 3.007 0 00-2.036.47 2.793 2.793 0 00-1.038 1.232 2.638 2.638 0 00-.158 1.571c.109.527.377 1.013.772 1.397.404.392.922.66 1.487.77A3.05 3.05 0 0012 16.522c.534-.207.992-.56 1.314-1.016.322-.455.495-.99.497-1.54v-3.055a3.88 3.88 0 002.189.664V10.09c-.154 0-.308-.014-.459-.044h-.018z",
    style: {
      animation: "tiktok .5s cubic-bezier(.6,.04,.98,.335) infinite both"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.cd9c7305d13036d5008f7b95b5166ad2.svg";
export { ForwardRef as ReactComponent };